// removed by extract-text-webpack-plugin
module.exports = {"wrap":"CwButton-wrap","small":"CwButton-small","inner":"CwButton-inner","innerStandard":"CwButton-innerStandard","large":"CwButton-large","innerMenu":"CwButton-innerMenu","topIcon":"CwButton-topIcon","disabled":"CwButton-disabled","topIconImage":"CwButton-topIconImage","rightIcon":"CwButton-rightIcon"};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwbutton/CwButton.scss
// module id = 990
// module chunks = 10